<template>
  <div>
    <h5 class="header-text">Colon Preparation Agent (複選)</h5>
    <template v-for="(n, index) in getList.length">
      <v-layout v-if="(index%2)==0" :key="n">
        <v-checkbox class="flex xs6 pl-0"
            :key="getList[index].value"
            :label="getList[index].text"
            :value="getList[index].value"
            v-model="selected"
            @change="selectOne(getList[index].value)"
            hide-details
        ></v-checkbox>
        <v-checkbox class="flex xs6 pl-0" v-if="getList[index+1]"
            :key="getList[index+1].value"
            :label="getList[index+1].text"
            :value="getList[index+1].value"
            v-model="selected"
            @change="selectOne(getList[index+1].value)"
            hide-details
        ></v-checkbox>
      </v-layout>
    </template>
    <v-layout class="others full-width">
        <v-checkbox class="pl-0"
          label="其他"
          v-model="othersSelected"
          hide-details
        ></v-checkbox>
        <v-text-field
          :value="data.clean_medOther"
          @change="selectOther($event)"
          hide-details
        ></v-text-field>
      </v-layout> 
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// note: this is the same as cleanMed -> this input might take it off later on
export default {
  name: 'PreparationAgentInput',

  props: {
    data: {
      type: Object,
      required: true
    },
  },

  data () {
    return {
      selected: this.data.clean_medIDs,
      othersSelected: false
    }
  },

  computed: {
    ...mapGetters('examinations', [
      'getCleanMedList'
    ]),

    getList () {
      return this.getCleanMedList.map((item, index)=> {
        return {
          text: item.clean_med,
          value: item.id
        }
      })
    }
  },
  methods: {
    selectOne(value) {
      this.$emit('change', { field: 'clean_medID', event: this.selected.join(",") })
    },
    selectOther(value) {
      this.$emit('change', { field: 'clean_medOther', event: value })
      this.othersSelected = (value && value.length > 0)
    }
  },
  mounted() {
    this.othersSelected = (this.data.clean_medOther && this.data.clean_medOther.length > 0)
  }
}
</script>